import React, { useCallback, useEffect, useState } from 'react';
import store from '../../redux/store';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@material-ui/core';
import TableView from '../TableView/TableView';
import EditIcon from '@material-ui/icons/Edit';
import AddBoxIcon from '@material-ui/icons/AddBox';
import EquipmentCreateDialog from '../EquipmentCreateDialog/components/EquipmentCreateDialog';
import AssignmentModal from '../AssignmentModal/AssignmentModal';
//imports for edit Equipment
// Equipment translations
import {
  assignUnassignEquipments,
  clearPaginationInfo,
  getEntities as getEquipments,
  getEquipmentsTranslation,
  setEntityToEdit,
  setPage,
  setRowsPerPage,
} from '../../redux/actions/equipmentsActions';
import EditEquipmentModal from '../EditEquipmentModal/EditEquipmentModal';

import { getEntities as getApprovalTypes } from '../../redux/actions/approvalTypesActions';
import { getAllEntitiesCatalog as getCategories } from '../../redux/actions/categoriesActions';
import { getAllEntitiesCatalog as getManufacturers } from '../../redux/actions/manufacturersActions';
import { getEntities as getModels } from '../../redux/actions/modelsActions';
import { getEntities as getCalibrationProfiles } from '../../redux/actions/calibrationProfilesActions';
import {
  getGlobalCountries,
  getRegions,
} from '../../redux/actions/regionsActions';
import {
  ableAssignmentButton,
  disableAssignmentButton,
} from '../../redux/actions/utilsActions';
import { selectModelsName } from '../../redux/selectors/modelsSelector';
import ColumnInterface from '../../interfaces/column';
import RBIAvailabilityButton from '../RBIAvailabilityButton/RBIAvailabilityButton';
import RBISearchButton from '../RBISearchButton/RBISearchButton';
import RBISelectButton from '../RBISelectButton/RBISelectButton';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import { EQUIPMENTS_EDIT_EQUIPMENT } from '../../redux/action-types/equipments-types';
import { actionListener, propertyToggle } from '../../utils/helpers';
import EquipmentTranslationsModal from '../EquipmentTranslations/EquipmentTranslationsModal';
import { useTranslation } from 'react-i18next';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { SET_SELECTED_LANGUAGE } from '../../redux/action-types/app-types';
import { textToSnakeCase } from '../../utils/utils';
import AppConstants from '../../AppConstants';

function EquipmentTab() {
  const dispatch: any = useDispatch();
  const { t } = useTranslation();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const paginationConfig = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.paginationConfig,
  );
  const equipments = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.entities,
  );
  const models = useSelector((state: RootStateOrAny) =>
    selectModelsName(state),
  );
  const approvalTypes = useSelector(
    (state: RootStateOrAny) => state.ApprovalTypesReducer.entities,
  );

  const categories = useSelector(
    (state: RootStateOrAny) => state.CategoriesReducer.entitiesCatalog,
  );
  const suppliers = useSelector(
    (state: RootStateOrAny) => state.ManufacturersReducer.entitiesCatalog,
  );
  const [equipmentsTreated, setEquipmentsTreated] = useState([]);
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  const { globalCountries } = useSelector(
    (store: RootStateOrAny) => store.RegionsReducer,
  );
  useEffect(() => {
    dispatch(getGlobalCountries());
  }, []);

  /////////////handle edit equipment details
  const [editModalOpen, setEditModalOpen] = useState(false);
  const handleClickOpen = id => async () => {
    const equipmentToEdit = await equipments.find(
      equipment => equipment.id === id,
    );
    dispatch(getEquipmentsTranslation(equipmentToEdit.id, selectedBrand));
    dispatch(setEntityToEdit(equipmentToEdit));
    setEditModalOpen(true);
  };
  //////////////////
  // Availability Filter
  const [availabilityFilter, setAvailabilityFilter] = useState<any[]>([]);
  const [parsedAvailabilityFilter, setParsedAvailabilityFilter] = useState<any>(
    {},
  );
  const handleAvailabilityFilterChange = (value, parsedValue) => {
    setAvailabilityFilter(value);
    setParsedAvailabilityFilter(parsedValue);
  };

  //////////////////

  const [openCreateModal, setOpenCreateModal] = useState(false);
  useEffect(() => {
    setEquipmentsTreated(
      equipments.map(e => {
        const newEquipment = { ...e };

        newEquipment.action = (
          <>
            {thisUser.hasEditEquipment ? (
              <IconButton onClick={handleClickOpen(e.id)}>
                <EditIcon />
              </IconButton>
            ) : thisUser.hasViewEquipment ? (
              <IconButton onClick={handleClickOpen(e.id)}>
                <VisibilityIcon />
              </IconButton>
            ) : (
              ''
            )}
          </>
        );
        newEquipment.visible = propertyToggle(
          e.is_visible_for_franchise,
          'Visible',
          'Non-visible',
        );
        newEquipment.core = propertyToggle(
          e.is_core,
          t('equipment.core'),
          t('equipment.nonCore'),
        );
        newEquipment.requires_training = propertyToggle(
          e.requires_training,
          t('equipment.training'),
          t('equipment.noTraining'),
        );
        newEquipment.status = propertyToggle(
          e.is_active,
          t('app.common.active'),
          t('app.common.inactive'),
        );
        newEquipment.approval_type = t(
          `equipment.approval.type.${textToSnakeCase(e.approval_type?.name)}`,
          e.approval_type?.name,
        );
        newEquipment.category = t(
          `equipment.categories.${textToSnakeCase(e.equipment_category?.name)}`,
          e.equipment_category?.name,
        );
        newEquipment.supplier = t(
          `restaurant.equipment.supplier.${textToSnakeCase(
            e.manufacturer?.name,
          )}`,
          e.manufacturer?.name,
        );

        const availabilities = e?.equipment_availabilities
          ?.filter(a => a.is_exclusion === 0)
          .map(availability => {
            if (availability.country) {
              const country = globalCountries.find(
                country => country.id === availability.country.id,
              );

              availability.country.description = t(
                `app.common.countries.${textToSnakeCase(country?.iso3)}`,
                availability.country?.description,
              );
            }

            return availability;
          });

        newEquipment.availability = getAvailability(availabilities);
        return newEquipment;
      }),
    );
  }, [equipments]);
  const [searchObject, setSearchObject] = useState<any>({
    availability: '',
    category: '',
    supplier: '',
    model: '',
    status: '',
    core: '',
    franchise: '',
    type: '',
    description: '',
  });
  const [searchObjectPrev, setSearchObjectPrev] = useState<any>({
    availability: '',
    category: '',
    supplier: '',
    model: '',
    status: '',
    core: '',
    franchise: '',
    type: '',
    description: '',
  });

  const [labelSelects, setLabelSelects] = useState<any>({
    status: '',
    core: '',
    franchise: '',
  });

  useEffect(() => {
    const unsubscribeEquipmentEdit = actionListener(
      store,
      EQUIPMENTS_EDIT_EQUIPMENT.SUCCESS,
      function () {
        dispatch(
          getEquipments({
            ...parsedAvailabilityFilter,
            page: paginationConfig.page,
            limit: paginationConfig.rowsPerPage,
            brand: selectedBrand,
            ...searchObjectPrev,
            type: searchObjectPrev.type.id,
            category: searchObjectPrev.category.id,
            supplier: searchObjectPrev.supplier.id,
            model: searchObjectPrev.model.name,
          }),
        );
      },
    );
    const unsubscribeChangeTranslation = actionListener(
      store,
      SET_SELECTED_LANGUAGE,
      function () {
        dispatch(
          getEquipments({
            ...parsedAvailabilityFilter,
            page: paginationConfig.page,
            limit: paginationConfig.rowsPerPage,
            brand: selectedBrand,
            ...searchObjectPrev,
            type: searchObjectPrev.type.id,
            category: searchObjectPrev.category.id,
            supplier: searchObjectPrev.supplier.id,
            model: searchObjectPrev.model.name,
          }),
        );
      },
    );
    if (selectedBrand) {
      dispatch(clearPaginationInfo());
      dispatch(
        getEquipments({
          ...parsedAvailabilityFilter,
          page: 1,
          limit: AppConstants.rowsPerPage,
          brand: selectedBrand,
          ...searchObjectPrev,
          type: searchObjectPrev.type.id,
          category: searchObjectPrev.category.id,
          supplier: searchObjectPrev.supplier.id,
          model: searchObjectPrev.model.name,
        }),
      );
      dispatch(
        getApprovalTypes(selectedBrand, {
          _disableRequestStatus: true,
        }),
      );
      dispatch(
        getCategories(
          {
            brand: selectedBrand,
            paginated: 1,
            status: 1,
            limit: 100,
          },
          {
            _disableRequestStatus: true,
          },
        ),
      );
      dispatch(
        getModels(
          {
            brand: selectedBrand,
            all: true,
          },
          {
            _disableRequestStatus: true,
          },
        ),
      );
      dispatch(
        getManufacturers(
          {
            brand: selectedBrand,
            category: searchObjectPrev.category.id,
            limit: 100,
          },
          {
            _disableRequestStatus: true,
          },
        ),
      );
      dispatch(
        getCalibrationProfiles(0, {
          _disableRequestStatus: true,
        }),
      );
      dispatch(
        getRegions(
          {},
          {
            _disableRequestStatus: true,
          },
        ),
      );
    }
    dispatch(setPage(1));

    return function () {
      unsubscribeEquipmentEdit();
      unsubscribeChangeTranslation();
    };
  }, [selectedBrand]);

  const handleChangeAutocomplete = (name: string, value: any) => {
    setSearchObjectPrev({
      ...searchObject,
      [name]: propertyToggle(value, value, ''),
    });
    if (!value) {
      setSearchObject({
        ...searchObject,
        [name]: propertyToggle(value, value, ''),
      });
    }
  };

  const [modelInput, setModelInput] = useState<string>('');
  const [timer, setTimer] = useState<any>(null);

  const callBackFunctionModels = useCallback(
    value => {
      clearTimeout(timer);
      if (modelInput !== value && (value.length > 0 || value === '')) {
        setModelInput(value);
      }
    },
    [timer, setModelInput, setTimer],
  );
  const handleInputChangeAutocomplete = (name: string, value: any) => {
    if (name === 'model') {
      callBackFunctionModels(value);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchObjectPrev({
      ...searchObject,
      [event.target.name]: event.target.value,
    });
  };

  const statusOptions = [
    { name: t('app.common.All'), value: 'All' },
    { name: t('app.common.active'), value: 1 },
    { name: t('app.common.inactive'), value: 0 },
  ];
  const franchiseOptions = [
    { name: t('app.common.All'), value: 'All' },
    { name: t('equipment.visible'), value: 1 },
    { name: t('equipment.nonVisible'), value: 0 },
  ];
  const coreOptions = [
    { name: t('app.common.All'), value: 'All' },
    { name: t('equipment.core'), value: 1 },
    { name: t('equipment.nonCore'), value: 0 },
  ];

  const handleChangeSelect = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => {
    const name = event.target.name as keyof typeof searchObject;
    let arraySelect: any = [];

    switch (name) {
      case 'core':
        arraySelect = coreOptions;
        break;
      case 'franchise':
        arraySelect = franchiseOptions;
        break;
      case 'status':
        arraySelect = statusOptions;
        break;
    }

    setSearchObjectPrev({
      ...searchObject,
      [name]: event.target.value,
    });

    setLabelSelects({
      ...labelSelects,
      [name]: arraySelect.reduce((newLabel, item) => {
        if (item.value === event.target.value && event.target.value !== '') {
          newLabel += item.name;
        }
        return newLabel;
      }, ''),
    });
  };

  const fetchDropdownValues = id => {
    const baseParams = {
      brand: selectedBrand,
      limit: 100,
      ...(searchObjectPrev.category?.id && {
        category: searchObjectPrev.category.id,
      }),
      ...(searchObjectPrev.supplier?.id && {
        supplier: searchObjectPrev.supplier.id,
      }),
      ...(searchObjectPrev.model?.name && {
        model: searchObjectPrev.model.name,
      }),
    };

    if (id !== 'category') {
      const { category, ...paramsWithoutCategory } = baseParams;
      dispatch(
        getCategories(paramsWithoutCategory, {
          _disableRequestStatus: true,
        }),
      );
    }
    if (id !== 'supplier') {
      const { supplier, ...paramsWithoutSupplier } = baseParams;
      dispatch(
        getManufacturers(paramsWithoutSupplier, {
          _disableRequestStatus: true,
        }),
      );
    }
    if (id !== 'model') {
      const { model, ...paramsWithoutModel } = baseParams;
      dispatch(
        getModels(paramsWithoutModel, {
          _disableRequestStatus: true,
        }),
      );
    }
  };

  const handleApplyButton = id => {
    setSearchObject({ ...searchObjectPrev });
    dispatch(setPage(1));
    fetchDropdownValues(id);
    dispatch(
      getEquipments({
        ...parsedAvailabilityFilter,
        page: 1,
        limit: paginationConfig.rowsPerPage,
        brand: selectedBrand,
        ...searchObjectPrev,
        type: searchObjectPrev.type.id,
        category: searchObjectPrev.category.id,
        supplier: searchObjectPrev.supplier.id,
        model: searchObjectPrev.model.name,
      }),
    );
  };

  const handleOnClosePopUp = () => {
    setSearchObjectPrev({
      ...searchObject,
    });

    if (searchObjectPrev.core || searchObjectPrev.core === 0) {
      setLabelSelects({
        ...labelSelects,
        core: '',
      });
    }

    if (searchObjectPrev.status || searchObjectPrev.status === 0) {
      setLabelSelects({
        ...labelSelects,
        status: '',
      });
    }

    if (searchObjectPrev.franchise || searchObjectPrev.franchise === 0) {
      setLabelSelects({
        ...labelSelects,
        franchise: '',
      });
    }
  };

  useEffect(() => {
    setSearchObjectPrev({
      ...searchObject,
    });

    if (searchObject.core || searchObject.core === 0) {
      setLabelSelects({
        ...labelSelects,
        core: coreOptions.reduce((newLabel, item) => {
          if (item.value === searchObject.core && searchObject.core !== '') {
            newLabel += item.name;
          }
          return newLabel;
        }, ''),
      });
    }

    if (searchObject.status || searchObject.status === 0) {
      setLabelSelects({
        ...labelSelects,
        status: statusOptions.reduce((newLabel, item) => {
          if (
            item.value === searchObject.status &&
            searchObject.status !== ''
          ) {
            newLabel += item.name;
          }
          return newLabel;
        }, ''),
      });
    }

    if (searchObject.franchise || searchObject.franchise === 0) {
      setLabelSelects({
        ...labelSelects,
        franchise: franchiseOptions.reduce((newLabel, item) => {
          if (
            item.value === searchObject.franchise &&
            searchObject.franchise !== ''
          ) {
            newLabel += item.name;
          }
          return newLabel;
        }, ''),
      });
    }
  }, [
    searchObject.availability,
    searchObject.category,
    searchObject.supplier,
    searchObject.model,
    searchObject.status,
    searchObject.core,
    searchObject.franchise,
    searchObject.type,
  ]);

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };
  const handleCloseCreateModal = () => {
    setOpenCreateModal(false);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(setRowsPerPage(+event.target.value));
    dispatch(setPage(1));
    dispatch(
      getEquipments({
        ...parsedAvailabilityFilter,
        page: 1,
        limit: +event.target.value,
        brand: selectedBrand,
        ...searchObject,
        type: searchObject.type.id,
        category: searchObject.category.id,
        supplier: searchObject.supplier.id,
        model: searchObject.model.name,
      }),
    );
  };

  const handleRefreshOnCreate = () => {
    dispatch(setPage(1));
    dispatch(
      getEquipments({
        ...parsedAvailabilityFilter,
        page: 1,
        limit: paginationConfig.rowsPerPage,
        brand: selectedBrand,
        ...searchObject,
        type: searchObject.type.id,
        category: searchObject.category.id,
        supplier: searchObject.supplier.id,
        model: searchObject.model.name,
      }),
    );
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    dispatch(setPage(newPage + 1));
    dispatch(
      getEquipments({
        ...parsedAvailabilityFilter,
        page: newPage + 1,
        limit: paginationConfig.rowsPerPage,
        brand: selectedBrand,
        ...searchObject,
        type: searchObject.type.id,
        category: searchObject.category.id,
        supplier: searchObject.supplier.id,
        model: searchObject.model.name,
      }),
    );
  };
  useEffect(() => {
    return () => {
      dispatch(disableAssignmentButton());
    };
  }, []);

  const [equipmentSelected, setEquipmentSelected] = useState([]);
  const [equipmentSelectedData, setEquipmentSelectedData] = useState([]);
  const checkSelected = selectedRows => {
    if (
      selectedRows?.length &&
      selectedRows?.length <= 50 &&
      thisUser.hasAssignEquipment
    ) {
      setEquipmentSelected(selectedRows.map(e => Number(e.id)));
      setEquipmentSelectedData(selectedRows);
      dispatch(ableAssignmentButton());
    } else {
      dispatch(disableAssignmentButton());
      if (thisUser.hasAssignEquipment && selectedRows?.length > 50) {
        dispatch(snackbarShowMessage(t('equipment.limitexceded')));
      }
    }
  };

  const [clearFlag, setClearFlag] = useState(false);

  const clearSelectedEquipments = flag => {
    setClearFlag(flag);
  };
  const assignUnassignToRestaurants = async (
    assign,
    reportingUnit,
    restaurants,
  ) => {
    const objToAssign = {
      reporting_unit: reportingUnit,
      restaurants,
      equipments: equipmentSelected,
      assign,
    };
    const response: any = await dispatch(assignUnassignEquipments(objToAssign));
    if (response?.status === 200) {
      dispatch(
        snackbarShowMessage(
          assign
            ? response?.data?.message === t('equipment.errorSelectedItems')
              ? t('equipment.errorSelectedItems')
              : t('equipment.successfulAssignMessage')
            : t('equipment.successfulUnassignedMessage'),
        ),
      );
    } else {
      dispatch(
        snackbarShowMessage(
          assign
            ? t('equipment.ErrorAssignMessage')
            : t('equipment.ErrorUnassignMessage'),
        ),
      );
    }
    clearSelectedEquipments(true);
  };
  // Equipment translation functionality
  const [OpenEquipmentTranslation, setOpenEquipmentTranslation] =
    useState(false);
  const [equipmentTranslationSelected, setEquipmentTranslationSelected] =
    useState(null);
  const showEquipmentTranslation = equipmentId => async () => {
    setEquipmentTranslationSelected(equipmentId);
    getEquipmentsTranslation(
      equipmentId,
      selectedBrand,
    )(dispatch)
      .then(response => {
        if (response.status < 300) {
          setOpenEquipmentTranslation(true);
        }
      })
      .catch(() => {
        dispatch(snackbarShowMessage('translation.errorOpeningMessage'));
      });
  };
  const handleCloseTranslationModal = () => {
    setOpenEquipmentTranslation(false);
  };

  function getAvailability(availabilities) {
    return availabilities[0]?.region_id === null &&
      availabilities[0]?.country_id === null &&
      availabilities[0]?.state_id === null
      ? 'Global'
      : availabilities.slice(0, 4).map((a, index) => {
          if (a?.state?.description) {
            return ` ${a.state.description}`;
          } else if (a?.country?.description) {
            return a.country?.description + ' ';
          } else if (a?.region_id) {
            return `${a.region_id} `;
          } else if (index === 4) {
            return '...';
          }
          return '';
        });
  }

  ////////////////////////////////////////////////

  const columns: ColumnInterface[] = [
    {
      id: 'availability',
      label: (
        <RBIAvailabilityButton
          value={availabilityFilter}
          includeStates={true}
          onChange={handleAvailabilityFilterChange}
          onApply={handleApplyButton}
        />
      ),
      align: 'left',
      minWidth: 85,
    },
    {
      id: 'category',
      label: (
        <RBISearchButton
          id={'category'}
          valueOption={searchObjectPrev['category']}
          labelText={t('equipment.category')}
          onChange={handleChangeAutocomplete}
          handleApplyButton={handleApplyButton}
          handleOnClosePopUp={handleOnClosePopUp}
          options={categories
            .map(option => ({
              ...option,
              name: t(
                `equipment.categories.${textToSnakeCase(option.name)}`,
                option.name,
              ),
            }))
            .sort(function (a, b) {
              const aName = (a.name || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
              const bName = (b.name || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
              return aName > bName ? 1 : aName < bName ? -1 : 0;
            })}
        />
      ),
      align: 'left',
      paddingLeft: 10,
      minWidth: 100,
    },
    {
      id: 'supplier',
      label: (
        <RBISearchButton
          id={'supplier'}
          valueOption={searchObjectPrev['supplier']}
          labelText={t('restaurant.equipment.supplier')}
          onChange={handleChangeAutocomplete}
          handleApplyButton={handleApplyButton}
          handleOnClosePopUp={handleOnClosePopUp}
          options={suppliers}
        />
      ),
      align: 'left',
      paddingLeft: 10,
    },
    {
      id: 'model',
      label: (
        <RBISearchButton
          id={'model'}
          valueOption={searchObjectPrev['model']}
          labelText={t('equipment.model')}
          onChange={handleChangeAutocomplete}
          onChangeInput={handleInputChangeAutocomplete}
          handleApplyButton={handleApplyButton}
          handleOnClosePopUp={handleOnClosePopUp}
          options={models}
        />
      ),
      align: 'left',
      paddingLeft: 10,
    },
    {
      id: 'description',
      label: (
        <RBISearchButton
          id={'description'}
          valueOption={searchObjectPrev['description']}
          labelText={t('equipment.description')}
          noOptions={true}
          onChange={handleChange}
          handleApplyButton={handleApplyButton}
          textButton={t('app.common.filter')}
          width={150}
        />
      ),
      align: 'left',
      minWidth: 140,
      paddingLeft: 10,
    },
    ...(thisUser.apptype !== 'FRUM'
      ? [
          {
            id: 'status',
            label: (
              <RBISelectButton
                id={'status'}
                valueOption={searchObjectPrev['status']}
                labelText={
                  labelSelects['status']
                    ? labelSelects['status']
                    : t('equipment.status')
                }
                onChangeInput={handleChangeSelect}
                options={statusOptions.map(option => ({
                  ...option,
                  name: t(
                    `app.common.countries.${textToSnakeCase(option.name)}`,
                    option.name,
                  ),
                }))}
                handleApplyButton={handleApplyButton}
                handleOnClosePopUp={handleOnClosePopUp}
              />
            ),
            align: 'left',
            paddingLeft: 10,
          },
        ]
      : []),
    {
      id: 'core',
      label: (
        <RBISelectButton
          id={'core'}
          valueOption={searchObjectPrev['core']}
          labelText={
            labelSelects['core'] ? labelSelects['core'] : t('equipment.core')
          }
          onChangeInput={handleChangeSelect}
          options={coreOptions}
          handleApplyButton={handleApplyButton}
          handleOnClosePopUp={handleOnClosePopUp}
        />
      ),
      align: 'left',
      paddingLeft: 10,
    },
    ...(thisUser.apptype !== 'FRUM'
      ? [
          {
            id: 'visible',
            label: (
              <RBISelectButton
                id={'franchise'}
                valueOption={searchObjectPrev['franchise']}
                labelText={
                  labelSelects['franchise']
                    ? labelSelects['franchise']
                    : t('equipment.visible')
                }
                onChangeInput={handleChangeSelect}
                options={franchiseOptions}
                handleApplyButton={handleApplyButton}
                handleOnClosePopUp={handleOnClosePopUp}
              />
            ),
            align: 'left',
            paddingLeft: 10,
          },
        ]
      : []),
    {
      id: 'requires_training',
      label: t('equipment.training'),
      align: 'left',
      minWidth: 85,
      paddingLeft: 10,
    },
    {
      id: 'approval_type',
      label: (
        <RBISearchButton
          id={'type'}
          valueOption={searchObjectPrev['type']}
          labelText={t('equipment.approval')}
          onChange={handleChangeAutocomplete}
          handleApplyButton={handleApplyButton}
          handleOnClosePopUp={handleOnClosePopUp}
          options={approvalTypes
            .map(option => ({
              ...option,
              name: t(
                `equipment.approval.type.${textToSnakeCase(option.name)}`,
                option.name,
              ),
            }))
            .sort(function (a, b) {
              const aName = (a.name || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
              const bName = (b.name || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
              return aName > bName ? 1 : aName < bName ? -1 : 0;
            })}
        />
      ),
      align: 'left',
    },
    {
      id: 'action',
      label: (
        <>
          {thisUser.hasEditEquipment && (
            <IconButton onClick={handleOpenCreateModal}>
              <AddBoxIcon />
            </IconButton>
          )}
        </>
      ),
    },
  ];

  const afterSaveEdit = () => {
    setSearchObjectPrev({
      availability: '',
      category: '',
      supplier: '',
      model: '',
      status: '',
      core: '',
      franchise: '',
      type: '',
    });
    setSearchObject({
      availability: '',
      category: '',
      supplier: '',
      model: '',
      status: '',
      core: '',
      franchise: '',
      type: '',
    });
  };

  return (
    <div>
      {editModalOpen && (
        <EditEquipmentModal
          readOnly={!thisUser.hasEditEquipment}
          open={editModalOpen}
          setOpen={setEditModalOpen}
          showEquipmentTranslation={showEquipmentTranslation}
          onSave={afterSaveEdit}
        />
      )}
      <EquipmentTranslationsModal
        OpenEquipmentTranslation={OpenEquipmentTranslation}
        handleClose={handleCloseTranslationModal}
        EquipmentSelected={equipmentTranslationSelected}
      />
      <TableView
        columns={columns}
        rows={equipmentsTreated}
        paginationConfig={paginationConfig}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleChangePage={handleChangePage}
        messageEmptyArray={t('equipment.noEquipmentFound')}
        checkboxes
        checkSelected={checkSelected}
        clearFlag={clearFlag}
        clearSelectedEquipments={clearSelectedEquipments}
      />
      {openCreateModal && (
        <EquipmentCreateDialog
          open={openCreateModal}
          handleClose={handleCloseCreateModal}
          handleRefreshOnCreate={handleRefreshOnCreate}
        />
      )}
      <AssignmentModal
        assignUnassignToRestaurants={assignUnassignToRestaurants}
        equipmentSelected={equipmentSelectedData}
      />
    </div>
  );
}

export default EquipmentTab;
